import { FileText, Users, Package, CreditCard, Receipt, FileDown } from 'lucide-react'
import { Link } from 'react-router-dom'

const ICONS = {
  invoices: FileText,
  customers: Users,
  products: Package,
  payments: CreditCard,
  expenses: Receipt,
  'credit-notes': FileDown,
}

export default function EmptyState({ type = 'invoices', message, actionLabel, actionTo }) {
  const Icon = ICONS[type] || FileText

  return (
    <div className="text-center py-16 px-4">
      <div className="inline-flex items-center justify-center w-16 h-16 bg-gray-100 rounded-full mb-4">
        <Icon className="h-7 w-7 text-gray-400" />
      </div>
      <p className="text-gray-500 mb-4">{message || 'Nothing here yet.'}</p>
      {actionLabel && actionTo && (
        <Link to={actionTo} className="btn-primary">
          {actionLabel}
        </Link>
      )}
    </div>
  )
}
